// Generated by CoffeeScript 1.12.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/display_types/display_type',['require','backbone','models/question','sp/ui/questions/question_view'],function(require) {
  var DisplayType, Question, QuestionView, View;
  View = require('backbone').View;
  Question = require('models/question');
  QuestionView = require('sp/ui/questions/question_view');
  return DisplayType = (function(superClass) {
    extend(DisplayType, superClass);

    function DisplayType() {
      this.questionUpdateHandler = bind(this.questionUpdateHandler, this);
      return DisplayType.__super__.constructor.apply(this, arguments);
    }

    DisplayType.prototype.id = "survey-questions";

    DisplayType.prototype.currentIndex = 0;

    DisplayType.prototype.participant = null;

    DisplayType.prototype.hasBranches = false;

    DisplayType.prototype.initialize = function(options) {
      this.currentIndex = 0;
      return DisplayType.__super__.initialize.call(this, options);
    };

    DisplayType.prototype.initQuestion = function(data) {
      var question;
      question = new QuestionView({
        model: new Question(data)
      });
      question.definitions = this.model.get('language').definitions;
      question.on('next', this.nextButtonClickHandler);
      question.on('submit', this.submitButtonClickHandler);
      question.on('update', this.questionUpdateHandler);
      question.total = this.model.get('questions').length;
      question.index = _.findIndex(this.model.get('questions'), function(q) {
        return q._id === data._id;
      });
      if (_.isArray(this.participant.get('answers')) && this.participant.get('answers')[question.index] && this.participant.get('answers')[question.index].question === question.model.get('_id')) {
        question.values = this.participant.get('answers')[question.index].values;
        question.comments = this.participant.get('answers')[question.index].comments;
      }
      this.$el.append(question.render());
      return question;
    };

    DisplayType.prototype.recordAnswer = function(question) {
      var answers;
      if (question instanceof QuestionView && question.valid) {
        answers = this.participant.get('answers') || [];
        answers[question.index] = {
          index: question.index,
          question: question.model.get("_id"),
          values: question.values,
          comments: question.comments
        };
        this.participant.set('answers', answers);
        return true;
      } else {
        return false;
      }
    };

    DisplayType.prototype.questionUpdateHandler = function(question) {};

    DisplayType.prototype.nextButtonClickHandler = function(e) {};

    DisplayType.prototype.submitButtonClickHandler = function(e) {};

    return DisplayType;

  })(View);
});

